import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// core version + navigation, pagination modules:
import {Swiper, Navigation, Pagination, Thumbs, Autoplay, EffectCards} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";
const buildSwiperCustom = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;

    var delay = typeof sliderElm.dataset.delay !== 'undefined' ? sliderElm.dataset.delay : 2500 ;
    var slides_xs = typeof sliderElm.dataset.xs !== 'undefined' ? sliderElm.dataset.xs : 3 ;
    var slides_md = typeof sliderElm.dataset.md !== 'undefined' ? sliderElm.dataset.md : 4 ;
    var slides_lg = typeof sliderElm.dataset.lg !== 'undefined' ? sliderElm.dataset.lg : 5 ;
    var slides_xl = typeof sliderElm.dataset.xl !== 'undefined' ? sliderElm.dataset.xl : 6 ;

    var center_slides = typeof sliderElm.dataset.center_slides !== 'undefined' ? sliderElm.dataset.center_slides : false ;
    var center_slides_bounds = typeof sliderElm.dataset.center_slides_bounds !== 'undefined' ? sliderElm.dataset.center_slides_bounds : false ;
    var loop = typeof sliderElm.dataset.loop !== 'undefined' ? sliderElm.dataset.loop : false ;
    var navigation = typeof sliderElm.dataset.navigation !== 'undefined' ? sliderElm.dataset.navigation : false ;

    return new Swiper('[data-id="'+sliderIdentifier+'"]', {
        modules: [Navigation, Autoplay],
        direction:'horizontal',
        slidesPerView:slides_xs,
        spaceBetween:15,
        centeredSlides:center_slides,
        centeredSlidesBounds:center_slides_bounds,
        loop: loop,
        autoplay: {
            delay: delay,
            disableOnInteraction: false,
        },
        navigation: {
            enabled: navigation,
            nextEl: '.swiper-button-next-slide-' + sliderIdentifier,
            prevEl: '.swiper-button-prev-slide-' + sliderIdentifier,
            disabledClass:'!bg-gray-700 text-gray-200'
        },
        breakpoints: {
            // // xs
            // 520: {
            //     slidesPerView:1.6,
            //     spaceBetween:15,
            // },
            // // sm
            // 640:{
            //     slidesPerView:2,
            //     spaceBetween:15,
            // },
            // md
            768: {
                slidesPerView:slides_md,
                spaceBetween:15,
            },
            // lg
            1024:{
                slidesPerView:slides_lg,
                spaceBetween:15,
            },
            // xl
            1280:{
                slidesPerView:slides_xl,
                spaceBetween:15,
            },
            // 2xl
            // 1536: {

            // },
        }
    });
}

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

